import { render } from "./NewColis.vue?vue&type=template&id=012dddac&ts=true"
import script from "./NewColis.vue?vue&type=script&lang=ts"
export * from "./NewColis.vue?vue&type=script&lang=ts"

import "./NewColis.vue?vue&type=style&index=0&id=012dddac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__